import {trackLogout} from '@aboutyou/legacy-tracking-sdk';
import type {AuthMedium} from '@aboutyou/user';
import {resetCustomerDataOnceGuard} from '../utils/trackCustomerDataOnce';
import {useTracking} from '../utils/utils';

export const useTrackLogout = () => {
  const {TrackingClient, pageContextCallback} = useTracking();
  return ({
    action,
    label,
  }: {
    action: 'successful' | 'error';
    label?: AuthMedium;
  }) => {
    TrackingClient.track(
      trackLogout({
        action,
        label,
        page: pageContextCallback(),
      }),
    );

    if (action === 'successful') {
      resetCustomerDataOnceGuard();
    }
  };
};
